import { Box, Typography, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { MEASURE_TYPES } from "../../../../../utils/constants";
import { getStatusColor, priority, renderDetailTooltip } from "../constants";

export default function FormatMeasureValue({ type, value, measureAlert }) {
  if (type === "bloodpressure") {
    const systolic = measureAlert?.systolic;
    const diastolic = measureAlert?.diastolic;
    const mostSevere =
      priority[systolic?.status || "normal"] >=
      priority[diastolic?.status || "normal"]
        ? { key: "systolic", ...systolic }
        : { key: "diastolic", ...diastolic };
    return (
      <Box sx={{ display: "flex", gap: "3px", alignItems: "center" }}>
        <Tooltip
          title={
            mostSevere?.detail ? renderDetailTooltip(mostSevere?.detail) : null
          }
          placement="bottom"
          arrow
        >
          <Box sx={{ display: "flex", gap: "2px", justifyContent: "center" }}>
            <Typography
              sx={{
                fontSize: "14px",
                color: getStatusColor(mostSevere?.status).color,
              }}
            >
              {value?.systolic}/{value?.diastolic} mmHg
            </Typography>
          </Box>
        </Tooltip>
        {value?.bpm && (
          <>
            <span>|</span>
            <Tooltip
              title={
                mostSevere?.detail
                  ? renderDetailTooltip(measureAlert?.bpm?.detail)
                  : null
              }
              placement="bottom"
              arrow
            >
              <Box
                sx={{ display: "flex", gap: "2px", justifyContent: "center" }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: getStatusColor(measureAlert?.bpm?.status).color,
                  }}
                >
                  {value.bpm} bpm
                </Typography>
              </Box>
            </Tooltip>
          </>
        )}
      </Box>
    );
  }

  const dataSource = measureAlert || value || {};

  return (
    <Box
      sx={{
        display: "flex",
        gap: "3px",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      {Object.entries(dataSource).map(([key, alert], index) => {
        const measureTypeField =
          MEASURE_TYPES[type]?.fields?.[key.toLowerCase()];
        const unit = measureTypeField?.unit || "";
        const displayValue = value?.[key] ? `${value[key]} ${unit}` : "N/A";

        return (
          <React.Fragment key={key}>
            {index > 0 && <span>|</span>}
            <Tooltip
              title={alert?.detail ? renderDetailTooltip(alert?.detail) : null}
              placement="bottom"
              arrow
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  color: getStatusColor(alert?.status).color,
                }}
              >
                {displayValue}
              </Typography>
            </Tooltip>
          </React.Fragment>
        );
      })}
    </Box>
  );
}

FormatMeasureValue.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.shape().isRequired,
  measureAlert: PropTypes.shape().isRequired,
};
